import { relations, sql } from 'drizzle-orm'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../../auth'
import { Curriculum, Grade, SkillWeight, Subject } from '../../content'

export const LessonModuleSearch = pgTable(
  'lesson_module_search',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'cascade' }),
    searchTerm: text(),
    curriculumId: uuid().references(() => Curriculum.id, { onDelete: 'set null' }),
    gradeId: uuid().references(() => Grade.id, { onDelete: 'set null' }),
    subjectId: uuid().references(() => Subject.id, { onDelete: 'set null' }),
    skillWeightId: uuid().references(() => SkillWeight.id, { onDelete: 'set null' }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [index('idx_lesson_module_search_user').on(t.userId)],
)

export const lessonModuleSearchRelations = relations(LessonModuleSearch, ({ one }) => ({
  user: one(user, {
    fields: [LessonModuleSearch.userId],
    references: [user.id],
  }),
  curriculum: one(Curriculum, {
    fields: [LessonModuleSearch.curriculumId],
    references: [Curriculum.id],
  }),
  grade: one(Grade, {
    fields: [LessonModuleSearch.gradeId],
    references: [Grade.id],
  }),
  subject: one(Subject, {
    fields: [LessonModuleSearch.subjectId],
    references: [Subject.id],
  }),
  skillWeight: one(SkillWeight, {
    fields: [LessonModuleSearch.skillWeightId],
    references: [SkillWeight.id],
  }),
}))

export const InsertLessonModuleSearchSchema = createInsertSchema(LessonModuleSearch).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectLessonModuleSearchSchema = createSelectSchema(LessonModuleSearch)

export type InsertLessonModuleSearch = typeof LessonModuleSearch.$inferInsert
export type SelectLessonModuleSearch = typeof LessonModuleSearch.$inferSelect
